import axios from "axios";
import { MAIN_API } from "../api/MAIN_API";
import { changeStateValue } from "../redux/MainReducer";

export const getContent=(lang_id=1)=>async dispatch => {
    dispatch(changeStateValue({name:"loader", value:true}))
    return await axios.get(`${MAIN_API}/contents?lang_id=${lang_id}`)
    .then(resp=>{
        dispatch(changeStateValue({name:"loader", value:false}))
        dispatch(changeStateValue({name:"contentData", value: resp?.data}))
        return "success";
    }).catch(err=>{
        dispatch(changeStateValue({name:"loader", value:false}))
        return "error";
    })
}
export const getAbout=(lang_id=1)=>async dispatch => {
    dispatch(changeStateValue({name:"loader", value:true}))
    return await axios.get(`${MAIN_API}/about?lang_id=${lang_id}`)
    .then(resp=>{
        dispatch(changeStateValue({name:"loader", value:false}))
        dispatch(changeStateValue({name:"aboutData", value: resp?.data}))
        return "success";
    }).catch(err=>{
        dispatch(changeStateValue({name:"loader", value:false}))
        return "error";
    })
}
export const getContactData=(lang_id=1)=>async dispatch => {
    dispatch(changeStateValue({name:"loader", value:true}))
    return await axios.get(`${MAIN_API}/contact?lang_id=${lang_id}`)
    .then(resp=>{
        dispatch(changeStateValue({name:"loader", value:false}))
        dispatch(changeStateValue({name:"contactData", value: resp?.data}))
        return "success";
    }).catch(err=>{
        dispatch(changeStateValue({name:"loader", value:false}))
        return "error";
    })
}
export const getCategoryByNav=(lang_id=1)=>async dispatch => {
    dispatch(changeStateValue({name:"loader", value:true}))
    return await axios.get(`${MAIN_API}/category-nav?lang_id=${lang_id}`)
    .then(resp=>{
        dispatch(changeStateValue({name:"loader", value:false}))
        dispatch(changeStateValue({name:"categoryNav", value: resp?.data}))
        return "success";
    }).catch(err=>{
        dispatch(changeStateValue({name:"loader", value:false}))
        return "error";
    })
}
export const getServicesByNav=(lang_id=1)=>async dispatch => {
    dispatch(changeStateValue({name:"loader", value:true}))
    return await axios.get(`${MAIN_API}/services?lang_id=${lang_id}`)
    .then(resp=>{
        dispatch(changeStateValue({name:"loader", value:false}))
        dispatch(changeStateValue({name:"navServices", value: resp?.data}))
        return "success";
    }).catch(err=>{
        dispatch(changeStateValue({name:"loader", value:false}))
        return "error";
    })
}
export const getServices=(lang_id=1)=>async dispatch => {
    dispatch(changeStateValue({name:"loader", value:true}))
    return await axios.get(`${MAIN_API}/services?lang_id=${lang_id}`)
    .then(resp=>{
        dispatch(changeStateValue({name:"loader", value:false}))
        dispatch(changeStateValue({name:"services", value: resp?.data}))
        return "success";
    }).catch(err=>{
        dispatch(changeStateValue({name:"loader", value:false}))
        return "error";
    })
}
export const getOtherServices=(lang_id=1, service_id)=>async dispatch => {
    dispatch(changeStateValue({name:"loader", value:true}))
    return await axios.get(`${MAIN_API}/other-services?lang_id=${lang_id}&id=${service_id}`)
    .then(resp=>{
        dispatch(changeStateValue({name:"loader", value:false}))
        dispatch(changeStateValue({name:"otherServices", value: resp?.data}))
        return "success";
    }).catch(err=>{
        dispatch(changeStateValue({name:"loader", value:false}))
        return "error";
    })
}
export const getOtherProducts=(lang_id=1, service_id)=>async dispatch => {
    dispatch(changeStateValue({name:"loader", value:true}))
    return await axios.get(`${MAIN_API}/other-product?lang_id=${lang_id}&id=${service_id}`)
    .then(resp=>{
        dispatch(changeStateValue({name:"loader", value:false}))
        dispatch(changeStateValue({name:"otherProducts", value: resp?.data}))
        return "success";
    }).catch(err=>{
        dispatch(changeStateValue({name:"loader", value:false}))
        return "error";
    })
}
export const getMainSlider=(lang_id=1)=>async dispatch => {
    dispatch(changeStateValue({name:"loader", value:true}))
    return await axios.get(`${MAIN_API}/slider-images?lang_id=${lang_id}`)
    .then(resp=>{
        dispatch(changeStateValue({name:"loader", value:false}))
        dispatch(changeStateValue({name:"mainSlider", value: resp?.data}))
        return "success";
    }).catch(err=>{
        dispatch(changeStateValue({name:"loader", value:false}))
        return "error";
    })
}
export const getProducts=(lang_id=1, category_id="", sub_category_id="")=>async dispatch => {
    dispatch(changeStateValue({name:"loader", value:true}))
    return await axios.get(`${MAIN_API}/product?lang_id=${lang_id}&category_id=${category_id}&sub_category_id=${sub_category_id}`)
    .then(resp=>{
        dispatch(changeStateValue({name:"loader", value:false}))
        dispatch(changeStateValue({name:"productsData", value: resp?.data}))
        return "success";
    }).catch(err=>{
        dispatch(changeStateValue({name:"loader", value:false}))
        return "error";
    })
}
export const getProductsFooter=(lang_id=1, category_id="")=>async dispatch => {
    dispatch(changeStateValue({name:"loader", value:true}))
    return await axios.get(`${MAIN_API}/product?lang_id=${lang_id}&category_id=${category_id}`)
    .then(resp=>{
        dispatch(changeStateValue({name:"loader", value:false}))
        dispatch(changeStateValue({name:"productsDataFooter", value: resp?.data}))
        return "success";
    }).catch(err=>{
        dispatch(changeStateValue({name:"loader", value:false}))
        return "error";
    })
}
export const getCategories=(lang_id=1)=>async dispatch => {
    dispatch(changeStateValue({name:"loader", value:true}))
    return await axios.get(`${MAIN_API}/category?lang_id=${lang_id}`)
    .then(resp=>{
        dispatch(changeStateValue({name:"loader", value:false}))
        dispatch(changeStateValue({name:"categoresData", value: resp?.data}))
        return "success";
    }).catch(err=>{
        dispatch(changeStateValue({name:"loader", value:false}))
        return "error";
    })
}

export const getCertificates=(type="")=>async dispatch => {
    dispatch(changeStateValue({name:"loader", value:true}))
    return await axios.get(`${MAIN_API}/award?type=${type}`)
    .then(resp=>{
        dispatch(changeStateValue({name:"loader", value:false}))
        dispatch(changeStateValue({name:"certificates", value: resp?.data}))
        return "success";
    }).catch(err=>{
        dispatch(changeStateValue({name:"loader", value:false}))
        return "error";
    })
}
export const getThankyouletter=(type="")=>async dispatch => {
    dispatch(changeStateValue({name:"loader", value:true}))
    return await axios.get(`${MAIN_API}/award?type=${type}`)
    .then(resp=>{
        dispatch(changeStateValue({name:"loader", value:false}))
        dispatch(changeStateValue({name:"thankyouletter", value: resp?.data}))
        return "success";
    }).catch(err=>{
        dispatch(changeStateValue({name:"loader", value:false}))
        return "error";
    })
}
export const getLisences=(type="")=>async dispatch => {
    dispatch(changeStateValue({name:"loader", value:true}))
    return await axios.get(`${MAIN_API}/award?type=${type}`)
    .then(resp=>{
        dispatch(changeStateValue({name:"loader", value:false}))
        dispatch(changeStateValue({name:"lisences", value: resp?.data}))
        return "success";
    }).catch(err=>{
        dispatch(changeStateValue({name:"loader", value:false}))
        return "error";
    })
}
export const getOurMission=(lang_id)=>async dispatch => {
    dispatch(changeStateValue({name:"loader", value:true}))
    return await axios.get(`${MAIN_API}/our-mission?lang_id=${lang_id}`)
    .then(resp=>{
        dispatch(changeStateValue({name:"loader", value:false}))
        dispatch(changeStateValue({name:"ourMission", value: resp?.data}))
        return "success";
    }).catch(err=>{
        dispatch(changeStateValue({name:"loader", value:false}))
        return "error";
    })
}
export const getParetners=(lang_id)=>async dispatch => {
    dispatch(changeStateValue({name:"loader", value:true}))
    return await axios.get(`${MAIN_API}/partners?lang_id=${lang_id}`)
    .then(resp=>{
        dispatch(changeStateValue({name:"loader", value:false}))
        dispatch(changeStateValue({name:"partners", value: resp?.data}))
        return "success";
    }).catch(err=>{
        dispatch(changeStateValue({name:"loader", value:false}))
        return "error";
    })
}
export const getlanguages=()=>async dispatch => {
    dispatch(changeStateValue({name:"loader", value:true}))
    return await axios.get(`${MAIN_API}/language`)
    .then(resp=>{
        dispatch(changeStateValue({name:"loader", value:false}))
        dispatch(changeStateValue({name:"languages", value: resp?.data}))
        return "success";
    }).catch(err=>{
        dispatch(changeStateValue({name:"loader", value:false}))
        return "error";
    })
}




export const getSingleData=(url)=>async dispatch => {
    dispatch(changeStateValue({name:"loader", value:true}))
    return await axios.get(`${MAIN_API}/${url}`)
    .then(resp=>{
        dispatch(changeStateValue({name:"loader", value:false}))
        return resp?.data;
    }).catch(err=>{
        dispatch(changeStateValue({name:"loader", value:false}));
        console.log(err.response)
        return "";
    })
}